import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const SuccessFieldModalWrapper = styled.div`
  .modal-lable-style {
    margin-top: 16px;
  }
`;
